/**
 * Класс-маркер поддерева дизайн-системы: к нему привязан baseline острова
 * (см. `DesignSystemProvider`). Отдельным модулем, потому что его импортируют
 * порталы — они уезжают в `document.body` и поддерево теряют.
 *
 * @format
 */

export const DS_SCOPE_CLASS = 'ads-scope';
